import merge from 'lodash/merge';
import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.integrationApiUrl, {
  camelizeKeys: true,
});

export default {
  async getSalesforceCaseFields(brandId, axiosConfig = {}) {
    return axios.get('/salesforce/case_fields', merge({ params: { brandId } }, axiosConfig));
  },
  async getSalesforceMappings(brandId, axiosConfig = {}) {
    return axios.get('/salesforce/mappings', merge({ params: { brandId } }, axiosConfig));
  },
  async createOrReplaceSalesforceMappings(data, axiosConfig = {}) {
    return axios.put('/salesforce/mappings', data, axiosConfig);
  },
  async getSalesforceCase(brandId, caseId, axiosConfig = {}) {
    return axios.get('/salesforce/cases', merge({ params: { brandId, caseId } }, axiosConfig));
  },
  async getSalesforceAccount(brandIds, axiosConfig = {}) {
    return axios.get('/salesforce/accounts', merge({ params: { brandIds } }, axiosConfig));
  },
  async updateSalesforceMappings(data, axiosConfig = {}) {
    return axios.patch('/salesforce/mappings', data, axiosConfig);
  },
};
